// extracted by mini-css-extract-plugin
export default {"container":"Groups_container__GjAvu","group":"Groups_group__+PzQk","scroll":"Groups_scroll__F2vDN","top":"Groups_top__3ISsg","save":"Groups_save__6L3Xd"};